module.exports = __webpack_public_path__ + "e3f73231015a7c2ab22315bf7f3a7dcd.svg";